import { useState } from "react";

export const useEditingUser = () => {
    const [isUserEditing, setIsUserEditing] = useState(false);
    const [editedForms, setEditedForms] = useState([]);

    /**
     * Evento que maneja funcionalidad cuando cambia el Editor del formulario.
     * @param {*} editor 
     * @param {*} selectedFormId 
     * @returns 
     */
    const onCurrentEditorChange = (editor, selectedFormId) => {
        if (editor)
            setEditedForms([...editedForms, editor.formId]);

        if (editor && editor.formId === selectedFormId) {
            setIsUserEditing(true);
        }
        else {
            setIsUserEditing(false);
            if (editedForms.find(x => x === selectedFormId)) { // Si se dejó de editar, y estoy parado en ese form, lo saco de la lista
                setEditedForms(editedForms.filter(f => f !== selectedFormId));
                return true;
            }
            return false;
        }

        return false;
    }

    /**
     * Maneja funcionalidad que se ejecuta al cambiar el formulario seleccionado. 
     * @param {*} formId 
     * @returns devuelve true, si es q el formulario seleccionado tiene q hacer reload, false caso contrario. 
     */
    const onSelectedFormChange = (formId) => {
        setIsUserEditing(false); // Blanqueo block edition. 
        if (editedForms.find(x => x === formId)) { // Sacar de editedForms 
            setEditedForms(editedForms.filter(f => f !== formId));
            return true;
        }
        return false;
    }

    return { isUserEditing, editedForms, onCurrentEditorChange, onSelectedFormChange };
}